export const createShader = (gl: WebGL2RenderingContext, type: GLenum, source: string): WebGLShader => {
  var shader = <WebGLShader>gl.createShader(type)

  gl.shaderSource(shader!, source)
  gl.compileShader(shader!)
  return shader
}

export const createProgram = (gl: WebGL2RenderingContext, vertexShader: WebGLShader, fragmentShader: WebGLShader) => {
  const program = <WebGLProgram>gl.createProgram()
  gl.attachShader(program, vertexShader)
  gl.attachShader(program, fragmentShader)
  gl.linkProgram(program)

  // Check the link status
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    // something went wrong with the link
    console.error("Link failed:\n", gl.getProgramInfoLog(program))
    console.error("VS:\n", gl.getShaderInfoLog(vertexShader))
    console.error("FS:\n", gl.getShaderInfoLog(fragmentShader))
    throw "Err glsl"
  }
  return program
}

export const createVertex = (gl: WebGL2RenderingContext, program: WebGLProgram, vertices: Float32Array, uniformName: string) => {
  const vertexBuffer = gl.createBuffer()
  gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer)
  gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW)

  const aPositionLocation = gl.getAttribLocation(program, uniformName)
  gl.enableVertexAttribArray(aPositionLocation)
  gl.vertexAttribPointer(aPositionLocation, 2, gl.FLOAT, false, 0, 0)
}

export const setup = (vertexShaderStr: string, fragmentShaderStr: string, gl: WebGL2RenderingContext) => {
  const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderStr)
  const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderStr)
  const program = createProgram(gl, vertexShader, fragmentShader)

  createVertex(gl, program, new Float32Array([1, 1, 1, 0, 0, 1, 0, 1, 1, 0, 0, 0]), "aPosition")
  return program
}

export const resize = (width: number, height: number, gl: WebGL2RenderingContext, program: WebGLProgram) => {
  const canvas = <HTMLCanvasElement>gl.canvas
  canvas.width = (width * devicePixelRatio) | 0
  canvas.height = (height * devicePixelRatio) | 0
  canvas.style.width = width + "px"
  canvas.style.height = height + "px"
  gl.viewport(0, 0, canvas.width, canvas.height)
  gl.uniform2fv(gl.getUniformLocation(program, "u_resolution"), [canvas.width, canvas.height])
}

export const windowResolution = (ratio: number, w?: number, h?: number) => {
  const width = w ? w : window.innerWidth
  const height = h ? h : window.innerHeight
  const s = Math.min(width * ratio, height)
  return { width: Math.floor(s / ratio), height: s }
}

export const injectToShader = (shader: string, variable: string, value: string | number) => {
  if (variable.startsWith("float") && !value.toString().includes(".")) value = `${value}.`
  const declaration = `${variable} = ${value};`
  return shader.replace(`${variable};`, declaration)
}
